// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a {\n  color: #f1394b;\n}\n\nbody {\n  line-height: 1!important;\n  background-color: #f1f1f1;\n}", "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B","sourcesContent":["a {\n  color: #f1394b;\n}\n\nbody {\n  line-height: 1!important;\n  background-color: #f1f1f1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
